// General
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Grid, Row, Col } from 'react-bootstrap';

import StepHeaderBlock from './StepHeaderBlock';
import { Whitespace, Text } from '../common';
import InputHeader from '../common/FormComponents/InputHeader';
import Input from '../common/FormComponents/InputStyle';
import ListPlaceTips from '../../components/ListPlaceTips/ListPlaceTips';
import FormNav from '../common/FormComponents/FormNav';
import { observer } from 'mobx-react';
import { allowNumericKeysOnly } from './utils';
import PhotosUpload from './PhotoUpload/PhotosUpload';
import {
  createListingPhotos,
  removeListingPhotos,
  updateListingPhotoOrder,
} from './savePhotosQL';
import { observable } from 'mobx';

@observer
class Photos extends Component {
  @observable errorMessage = '';
  static propTypes = {
    store: PropTypes.object,
    nextPage: PropTypes.func,
  };

  deletePhoto = async fileName => {
    const { store } = this.props;
    if (store.published && store.photos.length === 1) {
      this.errorMessage =
        'Cannot delete only photo on a published listing.  Please unpublish your listing before removing this photo';
      return;
    }
    const isCover = store.coverPhotoName === fileName;
    const success = await store.deletePhoto(removeListingPhotos, fileName);
    if (success) {
      store.updatePhotoOrder();
      store.updateCoverPhoto(updateListingPhotoOrder);
    }
    // console.log('delete photo', success);
  };

  sendServer = async (fileName, fileType) => {
    const { store } = this.props;
    const vars = { fileName, fileType };

    async function saveFn(vars) {
      const photo = await createListingPhotos(vars)
        .then(result => {
          return result;
        })
        .catch(err => console.log('Photos.js - error', err));
      return photo;
    }

    await store.savePhotos(saveFn, [vars]);
  };

  render() {
    const { store, nextPage } = this.props;

    const visited = store.groupsVisited.photos;

    return (
      <Grid>
        <Row>
          <Col xs={12} sm={7} md={7} lg={7}>
            <StepHeaderBlock headerText="Let's have some fun and add some photos," />
            <Whitespace smaller />
            <PhotosUpload
              placeholder="Click here to upload photos or drag them in. PNG, JPG, and JPEG supported."
              savePhotos={this.sendServer}
              store={store}
              removeListingPhoto={this.deletePhoto}
            />
            <Whitespace smaller />
            {visited && !store.currentGroupValid && (
              <Text error>{store.currentGroupErrors}</Text>
            )}
            {this.errorMessage && (
              <Text error noclip>
                {this.errorMessage}
              </Text>
            )}
            <FormNav nextPage={nextPage} store={store} />
          </Col>
          <Col>
            <ListPlaceTips
              tips={[
                {
                  title: 'Photo taking',
                  tips: [
                    'Take a real life photo - no stock photos.',
                    'At least 3 photos from different angles will help you win renters.',
                    'If there’s something special about your product, make sure there are great photos of it.',
                    'Take photos in a well lit area.',
                  ],
                },
                {
                  title: 'Cover Photo',
                  tips: [
                    'Select which photo you want to use as your cover photo - this will be the picture used in search results and the first picture renters see.',
                    'For best results, upload your cover photo as a square',
                    'Make sure the whole item is visible.',
                  ],
                },
                {
                  title: 'Removal',
                  tips: [
                    'Hit the "x" in the corner of a thumbnail to remove that picture.',
                  ],
                },
              ]}
            />
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default Photos;



// WEBPACK FOOTER //
// ./src/components_new/addListing/Photos.js